module.exports = __webpack_public_path__ + "img/up.d0fc43c6.svg";